































































































































































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import Report from '@/pdf/Report';
import PageFooter from '@/pdf/components/PageFooter.vue';
import Remarks from '@/pdf/components/Remarks.vue';

@Component({
  components: {
    PageFooter, Remarks },
})
export default class Accounting extends Report {
  async mounted() {
    await this.loadQuick('accounting');
  }
}
